
import AdUnit from '../components/AdUnit';
import React from 'react';
import { X, Check } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import { PageHero } from '../components/shared';
import SaveButton from '../components/SaveButton';
import AdSlot from '../components/AdSlot';
import { CULTURE_PAGE } from '../mock';

const Culture = () => {
  useReveal([]);
  const p = CULTURE_PAGE;
  return (
    <div className="bg-[#F6F1E3]">
      <PageHero image={p.hero} alt="Sheikh Zayed Grand Mosque" label={p.label} title={p.title} subtitle={p.subtitle} meta={p.meta} />
      <AdUnit slot="inline" />

      <article className="max-w-3xl mx-auto px-5 py-12 space-y-10">
        <div className="reveal flex justify-end">
          <SaveButton variant="pill" item={{ type: 'guide', ref_id: 'guide-culture', title: p.title, subtitle: p.label, to: '/culture-customs' }} />
        </div>
        {p.sections.map((s) => (
          <section key={s.heading} className="reveal">
            <h2 className="font-display text-[26px] font-semibold text-[#1B1D21]">{s.heading}</h2>
            <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">{s.body}</p>
          </section>
        ))}

        {/* Myth busters */}
        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21]">Myth vs reality</h2>
          <div className="mt-6 space-y-4">
            {p.mythBusters.map((m) => (
              <div key={m.myth} className="grid sm:grid-cols-2 gap-px rounded-2xl overflow-hidden border border-[#E6D7A2]">
                <div className="bg-[#fbeceb] p-5">
                  <div className="flex items-center gap-2 text-[#d6453c]">
                    <X className="w-4 h-4" />
                    <span className="text-[12px] font-semibold tracking-[0.14em] uppercase">Myth</span>
                  </div>
                  <p className="mt-2 text-[16px] text-[#5a4a33]">{m.myth}</p>
                </div>
                <div className="bg-[#eef6f4] p-5">
                  <div className="flex items-center gap-2 text-[#2F663C]">
                    <Check className="w-4 h-4" />
                    <span className="text-[12px] font-semibold tracking-[0.14em] uppercase">Reality</span>
                  </div>
                  <p className="mt-2 text-[16px] text-[#232528]">{m.truth}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <AdSlot slot="inContent" minH={140} className="reveal" />
      </article>
    </div>
  );
};

export default Culture;
